<aside class="sidebar" [class.closed]="isCollapsed" (mouseleave)="resetFlyout()">

  <!-- Logo Section -->
  <div class="logo-section">
    <div class="logo">
      <!-- <span>RTT</span> -->
      <img class="image" [src]="logoUrl" alt="Logo">
    </div>
    <div class="logo-text" *ngIf="!isCollapsed">
      <div class="logo-title" [attr.title]="companyName">{{companyName}}</div>
      <div class="logo-subtitle" [attr.title]="companyAddress">{{companyAddress}}</div>
    </div>
  </div>
  <!-- Dashboard Selector Dropdown -->
  <div *ngIf="!isCollapsed" class="dashboard-selector">
    <label class="dashboard-selector-label">Switch Dashboard</label>
    <div class="dashboard-dropdown">
      <select class="dashboard-select" id="dashboardSelect" [value]="getCurrentDashboard()"
        (change)="switchDashboard($event)" title="Select Dashboard">
        <option value="shipping">🚚 Shipping Dashboard</option>
        <option value="receiving">📦 Receiving Dashboard</option>
      </select>
    </div>
  </div>
  <!-- Navigation Menu -->
  <nav class="nav-menu" #navMenu (scroll)="onNavScroll($event)">
    <a *ngFor="let item of menuItems" class="nav-item" [class.active]="router.url.startsWith(item.route)"
      [routerLink]="item.icon !== 'ai' ? item.route : null"
      (click)="onMenuItemClick($event, item)" [attr.title]="isCollapsed ? item.label : null"
      style="cursor: pointer;">
      <!-- Icon -->
      <span class="nav-icon">
        <!-- SVG Icons (unchanged) -->
        <svg *ngIf="item.icon === 'analytics'" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
        </svg>
        <svg *ngIf="item.icon === 'home'" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
        </svg>
        <svg *ngIf="item.icon === 'package'" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
        </svg>
        <svg *ngIf="item.icon === 'bulk'" class="nav-icon" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
        </svg>
        <svg *ngIf="item.icon === 'warehouse'" class="nav-icon" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M7 14v-4H3v4h4zm2-4v4h4v-4H9zm2-2V4H7v4h4zm2 2v4h4v-4h-4zm2-2V4h-4v4h4zm-2 9v1c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-1h14z" />
          <path d="M3 4v4h2V4H3zm14 0v4h-2V4h2z" />
        </svg>
        <svg *ngIf="item.icon === 'users'" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
        </svg>
        <svg *ngIf="item.icon === 'notifications'" class="nav-icon" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
        </svg>
        <svg *ngIf="item.icon === 'address'" class="nav-icon" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clip-rule="evenodd" />
        </svg>
        <svg *ngIf="item.icon === 'map'" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z"
            clip-rule="evenodd" />
        </svg>
        <svg *ngIf="item.icon === 'companies'" class="nav-icon" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
            clip-rule="evenodd" />
        </svg>
        <svg *ngIf="item.icon === 'ticket'" class="nav-icon" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
          <path fill-rule="evenodd"
            d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clip-rule="evenodd" />
        </svg>
        <svg *ngIf="item.icon === 'user'" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
        </svg>
        <svg *ngIf="item.icon === 'bell'" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
        </svg>
        <svg *ngIf="item.icon === 'ai'" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2L14.4 9.1L21.5 11.5L14.4 13.9L12 21L9.6 13.9L2.5 11.5L9.6 9.1L12 2Z" />
        </svg>
        <svg *ngIf="item.icon === 'settings'" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
            clip-rule="evenodd" />
        </svg>
      </span>

      <!-- Label (Visible when expanded) -->
      <span class="nav-label" *ngIf="!isCollapsed">{{ item.label }}</span>

      <!-- Badge (Visible when expanded) -->
      <span class="nav-badge" *ngIf="item.badge && !isCollapsed">{{ item.badge }}</span>
    </a>

  </nav>

  <!-- Unified Sidebar Flyout Menu (Visible only when collapsed) -->
  <div class="full-sidebar-flyout" *ngIf="isCollapsed" [class.force-hidden]="isFlyoutClosedOnClick">
    <!-- Header with Company Info (Matches Sidebar Logo Area) -->
    <div class="flyout-header-main">
      <div class="flyout-company-info">
        <span class="flyout-company-name" [attr.title]="companyName">{{companyName}}</span>
        <span class="flyout-company-address" [attr.title]="companyAddress">{{companyAddress}}</span>
      </div>
      <div class="flyout-dashboard-selector">
        <select class="flyout-select" [value]="getCurrentDashboard()" (change)="switchDashboard($event)">
          <option value="shipping">🚚 Shipping</option>
          <option value="receiving">📦 Receiving</option>
        </select>
      </div>
    </div>

    <!-- Scrollable Menu List (Vertical items match sidebar icon positions) -->
    <div class="flyout-list" #flyoutList (scroll)="onFlyoutScroll($event)">
      <a *ngFor="let item of menuItems" class="flyout-link" [class.active]="router.url.startsWith(item.route)"
        [routerLink]="item.icon !== 'ai' ? item.route : null"
        (click)="onMenuItemClick($event, item)"
        style="cursor: pointer;">
        <span class="flyout-link-label">{{ item.label }}</span>
        <span class="flyout-link-badge" *ngIf="item.badge">{{ item.badge }}</span>
      </a>
    </div>

    <!-- Footer (Now fixed at bottom for perfect alignment with sidebar) -->
    <div class="flyout-footer">
      <div class="flyout-user-info">
        <div class="flyout-user-details">
          <div class="flyout-admin-name">{{adminName}}</div>
        </div>
        <button class="flyout-logout-btn" (click)="openLogout()" title="Logout">
          <svg fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
              clip-rule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- User Section -->
  <div class="user-section">
    <div class="user-avatar" (click)="openLogout()">
      <img src="assets/images/Logo.png" alt="RTT Logo" class="user-avatar-img">
    </div>
    <div class="user-info" *ngIf="!isCollapsed">
      <div class="user-name" [attr.title]="adminName">{{adminName}}</div>
    </div>
    <button (click)="openLogout()" class="logout-btn" *ngIf="!isCollapsed" title="Logout">
      <svg fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>

  <!-- Unified RTT Branding Footer -->
  <div class="sidebar-footer" *ngIf="!isCollapsed">
    <div class="brand-row">
      <div class="brand-text">Powered by <span class="brand-rtt">RTT</span></div>
    </div>
    <div class="app-version">{{ appVersion }}</div>
  </div>

</aside>
<div class="modal-backdrop" (click)="closeLogout()" *ngIf="showLogoutPopup">

  <div class="modal-card">

    <!-- Header -->
    <div class="modal-header">
      <h3>Logout</h3>
      <button class="close-btn" (click)="closeLogout()">✕</button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <p>Are you sure you want to logout?</p>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn cancel" (click)="closeLogout()">Cancel</button>
      <button class="btn danger" (click)="confirmLogout()">Logout</button>
      <!-- <button class="btn danger" (click)="confirmLogout()">Logout</button> -->
    </div>

  </div>

</div>